import React from 'react';
import classNames from "classnames";
import Typograf from 'typograf';

import "./vtrg_three_columns.scss";


const VtrgThreeColumns = ({ data, slot }) => {
  const tp = new Typograf({ locale: ["ru", "en-US"] });

  return(
    <div data-slot={slot} className="holder">
        <div className={classNames("three-columns-line")}>
          <div className="line-col">
            {data && data.bodyf && <div className="col-inside content" dangerouslySetInnerHTML={{__html: tp.execute(data.bodyf)}} />}
          </div>

          <div className="line-col">
            {data && data.bodys && <div className="col-inside content" dangerouslySetInnerHTML={{__html: tp.execute(data.bodys)}} />}
          </div>

          <div className="line-col">
            {data && data.bodyt && <div className="col-inside content" dangerouslySetInnerHTML={{__html: tp.execute(data.bodyt)}} />}
          </div>
        </div>
    </div>
  );
}

export default VtrgThreeColumns;